<script>
    import {API_URL} from "../../../../env";
    import {showDialogLogin} from "../../../js/stores";
    import {calculateProgressBar, checkPassword} from "../../../js/calculatePasswordStrength";
    import {addAlert} from "../../../js/alert";

    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    let isFetching = false

    let email = ""
    let password = ""
    let repeatedPassword = ""

    let emailBad = false
    let passwordBad = false
    let repeatedPasswordBad = false

    let errorReason = ""

    let passwordStrength = {
        strength: 0,
        progressBar: {
            color: "#B9B9B9",
            text: "",
            progress: 0,
        }
    }

    async function register() {
        if (isFetching) return;

        isFetching = true

        emailBad = false
        passwordBad = false
        repeatedPasswordBad = false

        errorReason = ""

        if (repeatedPassword.length < 8 || repeatedPassword !== password) {
            repeatedPasswordBad = true
            errorReason = "Heslá sa nezhodujú"
        }

        if (password.length < 8) {
            passwordBad = true
            errorReason = "Príliš krátke heslo"
        }

        if (!emailRegex.test(email)) {
            emailBad = true
            errorReason = "Zlý tvar e-mailu"
        }

        // Test if everything is ok
        if (emailBad || passwordBad || repeatedPasswordBad) return isFetching = false;

        // Fetch
        const body = {
            email,
            password
        }

        const res = await fetch(API_URL + '/users/register', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })


        if (!res.ok) {
            if (res.status === 409) {
                emailBad = true
                errorReason = "Účet s týmto emailom už existuje."
            }
            else if (res.status === 500 && await res.json().msg === "Cannot send email.") {
                emailBad = true
                addAlert("danger", "Chyba", "Chyba pri posielaní overovacieho emailu. Skúste sa prihlásiť a potom požiadať o opätovné zaslanie.")
            }
            else {
                addAlert("danger", "Chyba", "Pri registrácii nastala chyba. Skúste to prosím znova.")
            }

            return isFetching = false
        }

        isFetching = false
        showDialogLogin.set({show: true, type: "check", data: {title: "Účet bol úspešne vytvorený", text: "Na zadaný e-mail sme Vám zaslali odkaz na overenie účtu."}})
    }

    /*****/

    function checkRepeatedPassword(e) {
        repeatedPasswordBad = !(password === e.target.value)
    }

    function checkEmail(e) {
        emailBad = !emailRegex.test(e.target.value)
    }

    function handlePasswordStrength(e) {
        passwordStrength = checkPassword(e.target.value)
        passwordStrength.progressBar = calculateProgressBar(passwordStrength.strength)
    }
</script>

<div class="input-group mt-5 mb-3">
    <label for="email">E-mail</label>
    <input class:unfilled={emailBad} id="email" name="email" type="email" placeholder="E-mail" bind:value={email}>
</div>
<div class="input-group mb-3">
    <label for="password">Heslo</label>
    <input class:unfilled={passwordBad} id="password" name="password" type="password" placeholder="Heslo" bind:value={password} on:input={handlePasswordStrength}>
</div>
<div class="input-group mb-3">
    <label for="password">Heslo znova</label>
    <input class:unfilled={repeatedPasswordBad} id="repeatPassword" name="repeatPassword" type="password" placeholder="Heslo znova" bind:value={repeatedPassword} on:input={checkRepeatedPassword}>
</div>
<div class="input-group mb-2">
    <label for="password">Síla hesla</label>
    <div class="strength-bar" style="--progress-width: {passwordStrength.progressBar.progress}%; --progress-hex: {passwordStrength.progressBar.color};"></div>
</div>

<p class="text-danger text-right">{errorReason}</p>

<div class="d-flex justify-content-center mt-4">
    <button class="btn btn-slate-50" on:click={register}>
        {#if isFetching}
            <i class="fas fa-fw fa-spinner-third fa-spin mr-2"></i>
        {:else}
            <i class="fas fa-fw fa-user mr-2"></i>
        {/if}
        Registrovať sa
    </button>
</div>

<style>
    .input-group .strength-bar {
        width: 100%;
        height: 5px;
        background-color: #0000001A;
        border-radius: 1rem;
        margin: .5rem 0 1rem 0;
        position: relative;
    }
    .input-group .strength-bar:after {
        background-color: var(--progress-hex);
        width: var(--progress-width);
        position: absolute;
        height: 5px;
        border-radius: 1rem;
        top: 0;
        content: '';
    }
</style>